import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import SecondaryNavbar from '../../common/SecondaryNavbar/SecondaryNavbar';
import InsightsUsageContainer from './InsightsUsage/InsightstUsageContainer';
import InsightsMonthlySummaryContainer from './InsightsMonthlySummary/InsightsMonthlySummaryContainer';
import InsightsSimilarHomesContainer from './InsightsSimilarHomes/InsightsSimilarHomesContainer';
import InsightsBillAnalysisContainer from './InsightsBillAnalysis/InsightsBillAnalysisContainer';
import InsightsTimeOfUseAnalysis from './InsightsTimeOfUseAnalysis/InsightsTimeOfUseAnalysis';
import ErrorMain from '../../common/Error/ErrorMain';
import { DASHBOARD_INSIGHTS_BASE_PATH, INSIGHTS_PATH } from '../../../constants/paths';
import FooterMain from '../../standalone/common/Footer/FooterMain';
import { connect } from 'react-redux';
import { setPageTitle } from '../../../helpers/helper';


class InsightsPageMain extends React.Component {
  componentDidMount(){
    setPageTitle("ENERGY_INSIGHTS_PAGE.TITLE", this.props.translations.data, this.props.configs.data)
  }

  render(){
    const {USAGE, SIMILAR_HOMES, MONTHLY_SUMMARY, BILL_ANALYSIS, TIME_OF_USE_ANALYSIS} = INSIGHTS_PATH;
    return(
      <>
      <div className="component-wrapper insights-page-main">
        <SecondaryNavbar />
        {Object.keys(this.props.applianceList).length && (
          <Switch>
            <Redirect exact from={DASHBOARD_INSIGHTS_BASE_PATH} to={USAGE} />
            <Route exact path={USAGE} component={InsightsUsageContainer} />
            <Route exact path={MONTHLY_SUMMARY} component={InsightsMonthlySummaryContainer} />
            <Route exact path={SIMILAR_HOMES} component={InsightsSimilarHomesContainer} />
            <Route exact path={BILL_ANALYSIS} component={InsightsBillAnalysisContainer} />
            <Route exact path={TIME_OF_USE_ANALYSIS} component={InsightsTimeOfUseAnalysis} />
            <Route component={ErrorMain} />
          </Switch>
        )}
      </div>
      {this.props.configs && this.props.configs.data && this.props.configs.data["DASHBOARD.INSIGHTS_PAGE.FOOTER.SHOW"] === "true" ?
          (<FooterMain configs={this.props.configs} translations={this.props.translations} />)
          : ''
        }
    </>
    );
  }
}

const mapStateToProps = state => {
  return {
    configs: state.configs,
    translations: state.translationsData,
    applianceList: state.appliances.appliancesList
  }
}

export default connect(mapStateToProps)(InsightsPageMain);
